import botIcon from "../../../assets/images/chatbot.png";
import "../../../styles/ComponentStyles/Chatbot.css";

const ChatbotLauncher = ({ onOpen }) => {
  return (
    <button className="chatbot-launcher-icon" onClick={onOpen}>
      
    </button>
  );
};

export default ChatbotLauncher;
